const appSDK = {
    // 素材下载
    materialDownload(data) {
        console.log('素材下载', data);
        window.materialDownload.postMessage(JSON.stringify(data));
    },
    // 微信好友分享
    materialShareSession(data) {
        console.log('微信好友分享', data);
        window.materialShareSession.postMessage(JSON.stringify(data));
    },
    // 微信朋友圈分享
    materialShareTimeline(data) {
        console.log('微信朋友圈分享', data);
        window.materialShareTimeline.postMessage(JSON.stringify(data));
    },
    // 视频图片预览
    imageBrowser(data) {
        console.log('视频图片预览', data);
        window.imageBrowser.postMessage(JSON.stringify(data));
    },
    // 获取剪贴板内容
    getClipboard() {
        return new Promise((resolve) => {
            console.log('获取剪贴板内容');
            window.getClipboard.postMessage('');

            window.getClipboardCb = (data) => {
                console.log('获取到的剪贴板内容结果', decodeURIComponent(data));
                resolve(decodeURIComponent(data));
            };
        });
    },
    // 获取权限
    getAndroidPermissionBefore(data) {
        return new Promise((resolve) => {

            console.log('获取权限', data);
            window.getAndroidPermissionBefore.postMessage(JSON.stringify(data));

            window.getAndroidPermissionBeforeCb = (result) => {
                console.log('获取权限结果', JSON.parse(result));
                resolve(JSON.parse(result));
            };
        });
    },
    // 申请权限
    getPermission(data) {
        return new Promise((resolve) => {
            console.log('获取权限', data);
            window.getPermission.postMessage(JSON.stringify(data));

            window.getPermissionCb = (result) => {
                console.log('获取权限结果', JSON.parse(result));
                resolve(JSON.parse(result));
            };
        });
    },
    // 微信授权
    wxAuth() {
        return new Promise((resolve) => {
            console.log('微信授权');
            window.wxAuth.postMessage('');

            window.wxAuthCb = (wxCode) => {
                console.log('微信授权结果', wxCode);
                resolve(wxCode);
            };
        });
    },
    getNetworkHeader() {
        return new Promise((resolve) => {
            console.log('获取网络头部信息');
            window.getNetworkHeader.postMessage('');

            window.getNetworkHeaderCb = (result) => {
                console.log('获取网络头部信息结果', JSON.parse(result));
                resolve(JSON.parse(result));
            };
        });
    },
    loginOut(data) {
        console.log('登出');
        window.loginOut.postMessage(JSON.stringify(data));
    },
    cleanCache() {
        console.log('清理缓存');
        window.cleanCache.postMessage('');
    },
}

export default appSDK;